import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { routes } from "../../appRoutingHelpers";
import { OrganizationKeyName } from "../../model/Organization";
import { RegisterBeaconRequestLog } from "../../service/api-response/BeaconListSuccessResponse";
import { RootState } from "../../store";
import Spinner from "../common/Spinner";
import { PageHeader } from "../common/PageHeader";
import * as beaconSelectors from "./beaconSelectors";
import * as beaconActions from "./beaconActions";
import * as authSelectors from "../auth/authSelectors";
import moment from "moment";
import BeaconListFiltersForm from "./BeaconListFiltersForm";

interface Props {
  isLoadingBeacons: boolean;
  beacons: RegisterBeaconRequestLog[];
  organization: OrganizationKeyName;

  getBeacons: (
    organization: OrganizationKeyName,
    filters: any,
    page: number
  ) => void;
  hasMore: boolean;
}

interface State {
  filters: any;
  page: number;
}

const mapStateToProps = (state: RootState, ownProps: {}) => {
  return {
    organization: authSelectors.selectedOrganizationKeyName(state),
    isLoadingBeacons: beaconSelectors.isLoadingBeaconsForCurrentOrganization(
      state
    ),
    beacons: beaconSelectors.beaconsForCurrentOrganization(state),
    hasMore: true,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getBeacons: (
      organization: OrganizationKeyName,
      filters: any,
      page: number
    ) =>
      dispatch(
        beaconActions.getBeaconsForOrganizationAction(
          organization,
          filters,
          page
        )
      ),
  };
};

class BeaconList extends React.Component<Props, State> {
  state = {
    filters: undefined,
    page: 1,
  };

  onSearch = (values: any) => {
    this.setState({ filters: values, page: 1 }, () => {
      this.getData();
    });
  };

  onReset = () => {
    this.setState({ filters: undefined }, () => {
      this.getData();
    });
  };

  onLoadMoreBtnClick = (e: React.MouseEvent) => {
    e.preventDefault();

    this.setState({ page: this.state.page + 1 }, () => {
      this.getData();
    });
  };

  getData() {
    this.props.getBeacons(
      this.props.organization,
      this.state.filters,
      this.state.page
    );
  }

  componentDidMount() {
    this.getData();
  }

  render() {
    const t = (this.props as any).t;

    return (
      <div className="container">
        <PageHeader
          title="Beacons"
          breadcrumbs={[
            { title: "Beacons" },
            { title: "Overview", isActive: true },
          ]}
        />

        <div className="row row-cards row-deck">
          <div className="col-12">
            <BeaconListFiltersForm
              onSubmit={this.onSearch}
              onReset={this.onReset}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Beacon List</h3>
              </div>
              {this.props.beacons && (
                <div className="table-responsive">
                  <table className="table table-hover table-outline table-vcenter card-table">
                    <thead>
                      <tr>
                        <th>Beacon Id</th>
                        <th>Registration Status</th>
                        <th>Last Charge Date</th>
                        <th>Venue Ref</th>
                        <th>Pos Token</th>
                        <th>Terminal Token</th>
                        <th className="w-1" />
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.beacons.map((beacon) => (
                        <tr key={beacon.id}>
                          <td>
                            <Link
                              to={routes.beaconStatusView(
                                this.props.organization,
                                beacon.id,
                                beacon.beaconIdNfc
                              )}
                            >
                              {beacon.id}
                            </Link>
                          </td>
                          <td>{beacon.lastRegisterLogMessage}</td>
                          <td>
                            {beacon.lastChargeCreatedAt ? (
                              <>
                                {t("beacon.status_list.row.date", {
                                  date: moment(beacon.lastChargeCreatedAt),
                                })}
                              </>
                            ) : (
                              <>-</>
                            )}
                          </td>
                          <td>{beacon.venueRef}</td>
                          <td>{beacon.posToken}</td>
                          <td>{beacon.terminalToken}</td>
                          <td>
                            <Link
                              to={routes.beaconStatusView(
                                this.props.organization,
                                beacon.id,
                                beacon.beaconIdNfc
                              )}
                              className="btn btn-sm btn-primary"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <div className="card-footer text-center">
                {this.props.isLoadingBeacons ? (
                  <Spinner />
                ) : (
                  <>
                    {this.props.hasMore && (
                      <button
                        className="btn btn-link"
                        onClick={this.onLoadMoreBtnClick}
                      >
                        Load more
                      </button>
                    )}
                    {!this.props.hasMore && <span>No more beacon logs</span>}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(BeaconList));
